import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/** @param {any} props */
export default function LoadingSpinner({ className = null }) {
  return (
    <div
      className={classnames(className, 'w-100 loading-spinner')}
      data-test-id="loading-wrapper"
    />
  );
}

LoadingSpinner.propTypes = {
  className: PropTypes.string
};
